import { format } from 'date-fns';
import convertDateFormat from '../convertDateFormat';
/**
 * Format a date using date-fns, converting any 'D' or 'Y' in the supplied format to 'd' and 'y'
 * @param {Date} value date value
 * @param {String} dateFormat desired format
 * @returns {String}
 */ const safeFormat = (value, dateFormat)=>{
    const newFormat = convertDateFormat(dateFormat);
    return format(value, newFormat);
};
export default safeFormat;
